import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link as RouterLink } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

// Import your existing images or use these paths
const slides = [
  {
    src: "/assets/home.png", // Update with your image path
    title: "Your Trusted Partner in Packaging Solutions for the Cotton Industry",
    subtitle: "Specialized in serving cotton pressing and ginning industries with premium-quality PET straps, bale covers, washers, and strapping machines."
  },
  {
    src: "/assets/slide2.jpg", // Update with your image path
    title: "Premium Quality PET Straps",
    subtitle: "High-tensile strength PET straps specifically designed for cotton bale packaging with excellent durability."
  },
  {
    src: "/assets/slide3.jpg", // Update with your image path
    title: "Industrial Grade Pneumatic Tools",
    subtitle: "Professional pneumatic strapping machines for efficient cotton bale packaging operations."
  },
];

function Carousel() {
  return (
    <Box sx={{ position: "relative", height: { xs: "400px", md: "600px" } }}>
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={0}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        loop
        style={{ height: "100%" }}
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            {/* Background Image */}
            <Box
              sx={{
                position: "relative",
                width: "100%",
                height: "100%",
                backgroundImage: `url(${slide.src})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: "linear-gradient(rgba(33, 128, 141, 0.85), rgba(29, 116, 128, 0.9))",
                  zIndex: 1,
                },
              }}
            >
              {/* Centered Text */}
              <Container
                maxWidth="lg"
                sx={{
                  position: "relative",
                  zIndex: 2,
                  textAlign: "center",
                  color: "white",
                }}
              >
                <Typography
                  variant="h1"
                  sx={{
                    fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
                    fontWeight: 700,
                    mb: 3,
                    textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
                    lineHeight: 1.2,
                  }}
                >
                  {slide.title}
                </Typography>
                
                {slide.subtitle && (
                  <Typography
                    variant="h5"
                    sx={{
                      fontSize: { xs: "1rem", sm: "1.25rem", md: "1.5rem" },
                      mb: 4,
                      opacity: 0.9,
                      textShadow: "1px 1px 2px rgba(0,0,0,0.3)",
                      maxWidth: "800px",
                      mx: "auto",
                      lineHeight: 1.4,
                    }}
                  >
                    {slide.subtitle}
                  </Typography>
                )}
                
                <Box sx={{ display: "flex", gap: 2, justifyContent: "center", flexWrap: "wrap" }}>
                  <Button
                    component={RouterLink}
                    to="/products"
                    variant="contained"
                    size="large"
                    sx={{
                      px: 4,
                      py: 1.5,
                      fontSize: "1.1rem",
                      fontWeight: 600,
                      borderRadius: 2,
                      backgroundColor: "white",
                      color: "primary.main",
                      "&:hover": {
                        backgroundColor: "rgba(255, 255, 255, 0.9)",
                        transform: "translateY(-2px)",
                      },
                      transition: "all 0.3s ease",
                    }}
                  >
                    View Products
                  </Button>
                  
                  <Button
                    component={RouterLink}
                    to="/inquiry"
                    variant="outlined"
                    size="large"
                    sx={{
                      px: 4,
                      py: 1.5,
                      fontSize: "1.1rem",
                      fontWeight: 600,
                      borderRadius: 2,
                      borderColor: "white",
                      color: "white",
                      "&:hover": {
                        borderColor: "white",
                        backgroundColor: "rgba(255, 255, 255, 0.1)",
                        transform: "translateY(-2px)",
                      },
                      transition: "all 0.3s ease",
                    }}
                  >
                    Get Quote
                  </Button>
                </Box>
              </Container>
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
}

export default Carousel;
